module.exports = __webpack_public_path__ + "fonts/Inter-100-greek25.8c7f6ae.woff2";